import React, { useEffect, useState, useRef } from "react";
import Topbar from "../components/Topbar";
import Sidebar from "../components/Sidebar";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";

function Updatecatagory() {
  const { id } = useParams();
  const navigate = useNavigate();
  const token = sessionStorage.getItem("token");
  const baseUrl = process.env.REACT_APP_APIURL;

  const [loading, setLoading] = useState(false);
  const [formdata, setFormdata] = useState({
    catagoryname: "",
  });
  const [currentImage, setCurrentImage] = useState("");
  const [newImageFile, setNewImageFile] = useState(null);
  const [imagePreview, setImagePreview] = useState("");
  const fileInputRef = useRef(null);

  useEffect(() => {
    const fetchSingleCategory = async () => {
      if (!token) {
        toast.error("No token provided!");
        return;
      }

      try {
        const response = await axios.get(
          `${baseUrl}api/catagorydetails/${id}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.data?.category) {
          const { catagoryname, image } = response.data.category;
          setFormdata({ catagoryname });
          setCurrentImage(image);
        }
      } catch (error) {
        toast.error(
          "Error fetching data: " +
          (error.response?.data?.message || error.message)
        );
      }
    };

    fetchSingleCategory();
  }, [id, token, baseUrl]);

  const handleChange = (e) => {
    setFormdata({ ...formdata, [e.target.name]: e.target.value });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setNewImageFile(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const data = new FormData();
    data.append("catagoryname", formdata.catagoryname);
    if (newImageFile) {
      data.append("image", newImageFile);
    }

    try {
      const response = await fetch(
        `${baseUrl}api/updatecatagory/${id}`,
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: data,
        }
      );

      const responseData = await response.json();

      if (response.ok) {
        toast.success("Category updated successfully!");
        navigate("/category-list");
      } else {
        toast.error(responseData.message || "Failed to update category");
      }
    } catch (error) {
      toast.error("Something went wrong! Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Topbar />
      <Sidebar />
      <main id="main" className="main">
        <div className="pagetitle">
          <h1>Category</h1>
          <nav>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/">Home</Link>
              </li>
              <li className="breadcrumb-item active">Update Category</li>
            </ol>
          </nav>
        </div>

        <div className="card">
          <div className="card-body">
            <h5 className="card-title">Update Category</h5>
            <form className="row g-3 pt-3" onSubmit={handleSubmit}>
              <div className="col-md-12">
                <div className="form-floating">
                  <input
                    type="text"
                    className="form-control"
                    id="name"
                    placeholder="Enter Category Name"
                    name="catagoryname"
                    value={formdata.catagoryname}
                    onChange={handleChange}
                    required
                  />
                  <label htmlFor="name">Category Name</label>
                </div>
              </div>

              <div className="col-md-12">
                <label htmlFor="categoryImage" className="form-label">
                  Update Category Image
                </label>
                <input
                  type="file"
                  className="form-control"
                  id="categoryImage"
                  name="image"
                  onChange={handleFileChange}
                  ref={fileInputRef}
                  accept="image/*"
                />
              </div>

              <div className="col-12 mt-3">
                <p>Image Preview:</p>
                <img
                  src={
                    imagePreview ||
                    (currentImage
                      ? currentImage.startsWith("http")
                        ? currentImage
                        : `${baseUrl}api/${currentImage}`
                      : "https://placehold.co/200x200/EFEFEF/AAAAAA?text=No+Image")
                  }
                  alt="Category Preview"
                  style={{
                    maxWidth: "200px",
                    maxHeight: "200px",
                    borderRadius: "8px",
                    objectFit: "cover",
                  }}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "https://placehold.co/200x200/EFEFEF/AAAAAA?text=Error";
                  }}
                />
              </div>

              <div className="text-start d-flex gap-3 mt-4">
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={loading}
                >
                  {loading ? "Updating..." : "Update Category"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </main>
    </>
  );
}

export default Updatecatagory;
